import React from 'react'
import IntervalSlider, {
  IntervalSliderItem,
} from '@talentinc/gatsby-theme-ecom/components/IntervalSlider/IntervalSlider'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import LinkButton from '@talentinc/gatsby-theme-ecom/components/Link/LinkButton'
import { makeStyles } from 'tss-react/mui'
import useBrand from '../../hooks/useBrand'

type Item = {
  title: string
  description: string
  img: string
}

function LearnMore() {
  const { classes } = useStyles()

  const { t } = useTranslation()
  const { flagshipProduct, isTopCvFr } = useBrand()

  const items: IntervalSliderItem[] = t('learnMore.items', {
    returnObjects: true,
    defaultValue: [],
    flagshipProduct,
  }) as Item[]

  // hide button on TopCV.fr
  const howItWorksUrl = isTopCvFr ? null : `/how-top-${flagshipProduct?.toLowerCase()}-works`;

  return (
    <>
      <Box className={classes.header}>
        <Typography variant={'h2'}>
          {t('learnMore.header', { flagshipProduct })}
        </Typography>
        {!!howItWorksUrl &&
          <Box>
            <LinkButton href={howItWorksUrl} variant="contained">
              {t('navigation.hiw.linkText')}
            </LinkButton>
          </Box>
        }
      </Box>
      <IntervalSlider tabTimeOutInSecond={10} items={items} />
    </>
  )
}

export default LearnMore

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '2rem',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  },
}))
